import { CopyOutlined } from '@ant-design/icons'
import { Tooltip } from 'antd'
import React, { useState } from 'react'

export const CopyButton = ({ text }) => {
  const [isVisible, setIsVisible] = useState(false)

  const handleCopy = () => {
    navigator.clipboard.writeText(text.trim()).then(() => {
      setIsVisible(true)
      setTimeout(() => setIsVisible(false), 500)
    })
  }

  return (
    <Tooltip visible={isVisible} placement='topLeft' title='скопировано' trigger='click'>
      <CopyOutlined style={{ marginLeft: 10 }} onClick={handleCopy} />
    </Tooltip>
  )
}

export default CopyButton
